import { useEffect, useState } from 'react'

const useIsMounted = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted
}

// noinspection JSUnusedGlobalSymbols
export default useIsMounted
